module.exports = __webpack_public_path__ + "static/media/005_billing low fi @2x.7258b5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/backtrace/005_billing low fi @2x.png
// module id = 371
// module chunks = 0